"use client";
import {
  Box,
  Button,
  GridItem,
  Heading,
  SimpleGrid,
  Text,
  Stack,
  Highlight,
} from "@chakra-ui/react";
import {Balancer} from "react-wrap-balancer";
import PageLayout from "@/layouts/pageLayout";
import {
  useSectionHeadingVariant,
  useTextVariants,
} from "@/theme/components/useSectionHeading";
import BgImage from "public/shared/lbBg.png";
import {BUTTON_VARIANTS} from "@/theme/components/button";
import {scrollToElement} from "@/utils/scrollToElement";

type Props = {
  title: string;
  desc: {highlight: string | string[]; text: string}[];
};

const OmsSolutions = (props: Props) => {
  const {title, desc} = props;
  const HeadingVariant = useSectionHeadingVariant();
  const TextVariant = useTextVariants();

  return (
    <Box
      backgroundImage={BgImage.src}
      backgroundSize="cover "
      p={{base: 4, md: 12}}
      mt={14}
    >
      <PageLayout spacing={8} marginTop={12}>
        <SimpleGrid columns={{base: 1, sm: 2, md: 5}} spacing={{base: 8, md: 8, lg: 16}}>
          <GridItem colSpan={{base: 1, sm: 2, md: 2}}>
            <Heading as="h1" variant={HeadingVariant}>
              {title}
            </Heading>
          </GridItem>
          <GridItem colSpan={{base: 1, sm: 2, md: 3}}>
            <Stack spacing={4}>
              {desc.map((item, index) => (
                <Balancer key={index}>
                  <Text key={index} variant={TextVariant} color="text.100">
                    <Highlight
                      styles={{fontWeight: 600, color: "text.100"}}
                      query={item.highlight}
                    >
                      {item.text}
                    </Highlight>
                  </Text>
                </Balancer>
              ))}
            </Stack>
          </GridItem>
        </SimpleGrid>
        <Button
          onClick={() => scrollToElement("contact-us", 120)}
          variant={BUTTON_VARIANTS.IDEAL}
          borderRadius={"full"}
          minW={"150px"}
          alignSelf={"center"}
          mb={{base: 4, md: 0}}
        >
          Talk To Us
        </Button>
      </PageLayout>
    </Box>
  );
};

export default OmsSolutions;
